import { NgModule } from '@angular/core';
import { AuditTrailReasonComponent, REASONS_STORAGE_TOKEN } from './audit-trail-reason.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AuditTrailReasonsStorage } from './audit-trail-reasons-storage';

@NgModule({
    imports: [
        SharedModule,
        ReactiveFormsModule,

    ],
    exports: [
        AuditTrailReasonComponent,

    ],
    declarations: [
        AuditTrailReasonComponent,

    ],
    providers: [
        AuditTrailReasonsStorage,
        { provide: REASONS_STORAGE_TOKEN, useExisting: AuditTrailReasonsStorage }
    ],
})
export class AuditTrailModule { }
